import React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { isMobileDevice } from '@globalUtils/environment';

export const ComparisonSection = () => {
  const { t } = useTranslation();

  const itemsNumber = Number(t('comparisonItems') || '') || 0;
  const cols = ['', ...(t('comparisonItemsCols') || '').split('\n')];

  const renderRow = (items: string[], index: number, isHeader = false) => {
    const mobile = isMobileDevice();
    return (
      <div
        className="flex w-full py-3 rounded-sm cursor-default"
        style={{
          backgroundColor: index % 2 === 0 ? 'white' : 'var(--color-slate-100)',
          borderRadius: '8px',
        }}
      >
        {items.map((item, i) => (
          <div
            className="flex text-xs lg:text-sm"
            style={{
              justifyContent: i === 0 ? 'flex-start' : 'center',
              textAlign: i === 0 ? 'left' : 'center',
              alignItems: 'center',
              paddingLeft: i === 0 ? 'calc(var(--spacing) * 8)' : '',
              width: i === 0 ? `${mobile ? '30%' : '40%'}` : `${mobile ? '23.3%' : '20%'}`,
              fontWeight: isHeader ? 600 : i === 0 ? 500 : 400,
              color: isHeader ? '' : 'var(--color-gray-600)',
            }}
            key={`comparison-item-${i}`}
          >
            {item}
          </div>
        ))}
      </div>
    );
  };

  const renderItems = () => {
    const items: React.ReactNode[] = [];
    for (let i = 1; i <= itemsNumber; i++) {
      items.push(
        <React.Fragment key={`comparison-tab-${i}`}>
          {renderRow((t(`comparisonItem${i}`) || '').split('\n'), i)}
        </React.Fragment>
      );
    }
    return items;
  };

  const renderedItems = useMemo(() => renderItems(), [t]);

  return (
    <div className="w-full">
      <div className="w-full flex flex-col">
        {renderRow(cols, 0, true)}
        {renderedItems}
      </div>
    </div>
  );
};
